export default __webpack_public_path__ + "static/media/logo.eceb8d79.png";